module.exports = __webpack_public_path__ + "img/eight3Blue.f6523a0f.jpg";